var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-light fixed-top bg-primary",attrs:{"id":"pageHeader"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }